module.exports = __webpack_public_path__ + "static/media/mare-partitura.ee0e93a9.png";